import { capitalizeFirstLetter } from './capitalizeFirstLetter';

export function normalizeText(description?: string): string {
  return capitalizeFirstLetter(description?.toLowerCase() ?? '');
}
